// extracted by mini-css-extract-plugin
export var card = "_vd-0";